module.exports = __webpack_public_path__ + "img/mkyo-checkpoint-model-selector.2923dd1e.png";